export default "__VITE_ASSET__a6800dd3__"